<template>
  <UIDialog
    :is-open
    :z-index
    :unclosable
    title="You have invitation to collaboration"
    size="lg"
    @close="handleClose"
  >
    <InvitesGrid @go-to-repo="handleGoToRepo" />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'
import InvitesGrid from './InvitesGrid.vue'

type Props = {
  modal: ModalClass<any>
  unclosable?: boolean
}

type Emits = {
  'go-to-repo': [data: string, callback?: () => void]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleGoToRepo = (repositoryId: string) => {
  emit('go-to-repo', repositoryId, () => {
    props.modal.close()
  })
}

const handleClose = () => {
  props.modal.close()
}
</script>
